import type { IErrorBlockProps } from "@newxsystems/types";

export function ErrorBlock({
  description = "The content provider could not load this page.",
  homeHref = "/",
  homeLabel = "Go home",
  retryHref,
  retryLabel = "Try again",
  statusCode = 500,
  title = "Page unavailable",
}: IErrorBlockProps) {
  return (
    <section className="mx-auto flex min-h-[70vh] max-w-3xl flex-col items-start justify-center px-6 py-20">
      <p className="mb-4 text-sm font-semibold uppercase tracking-[0.3em] text-neutral-500">
        {statusCode}
      </p>
      <h1 className="text-4xl font-semibold tracking-tight text-neutral-950 md:text-6xl">
        {title}
      </h1>
      <p className="mt-6 max-w-xl text-lg leading-8 text-neutral-600">{description}</p>
      <div className="mt-8 flex flex-wrap gap-3">
        {retryHref ? (
          <a
            href={retryHref}
            className="inline-flex rounded-full bg-neutral-950 px-5 py-3 text-sm font-semibold text-white transition hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2"
          >
            {retryLabel}
          </a>
        ) : null}
        <a
          href={homeHref}
          className="inline-flex rounded-full border border-neutral-300 px-5 py-3 text-sm font-semibold text-neutral-950 transition hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2"
        >
          {homeLabel}
        </a>
      </div>
    </section>
  );
}

ErrorBlock.displayName = "Start::ErrorBlock";
